/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class EquipmentService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'EquipmentService\' loaded');
    }
}

export { EquipmentService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/equipment/service/EquipmentService.js